// ESM mirror of slug.ts so the build-time scripts/generate-sitemap.mjs can
// reuse the same slugify pipeline without resolving a .ts file. Keep this
// in lockstep with slug.ts (same alphabet, same NFKD normalization, same
// 80-char cap). If you change one, change both.

const CYRILLIC_TO_LATIN = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'yo',
  ж: 'zh', з: 'z', и: 'i', й: 'y', к: 'k', л: 'l', м: 'm',
  н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u',
  ф: 'f', х: 'h', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'sch',
  ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
  '№': '',
}

const COMBINING_MARKS = /[̀-ͯ]/g

function transliterateCyrillic(input) {
  let out = ''
  for (const ch of input) {
    const lower = ch.toLowerCase()
    out += CYRILLIC_TO_LATIN[lower] ?? ch
  }
  return out
}

export function slugify(name, fallback) {
  const transliterated = transliterateCyrillic(String(name ?? ''))
  const normalized = transliterated.normalize('NFKD').replace(COMBINING_MARKS, '')
  const lowered = normalized.toLowerCase()
  const dashed = lowered.replace(/[^a-z0-9]+/g, '-')
  const collapsed = dashed.replace(/-+/g, '-')
  const trimmed = collapsed.replace(/^-+|-+$/g, '')
  const truncated = trimmed.slice(0, 80).replace(/-+$/g, '')
  if (truncated.length === 0 && fallback) return `club-${fallback}`
  return truncated
}
